import { createContext, useContext, ReactNode, useState, useEffect } from 'react';
import { useSessionStorage } from '../hooks';
import { SoTravelTravelData } from '../apiGraphql/types/types';

interface GeneralSoContextType {
  soId?: string;
  setSoId: (id: string | undefined) => void;
  soInitialData?: SoTravelTravelData;
  setSoInitialData: (data: SoTravelTravelData | undefined) => void;
  offerId?: string;
  setOfferId: (offerId: string | undefined) => void;
}

const GeneralSoContext = createContext<GeneralSoContextType | undefined>(undefined);

export const GeneralSoProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [soId, setSoIdState] = useState<string | undefined>(undefined);
  const [soInitialData, setSoInitialData] = useState<SoTravelTravelData | undefined>(undefined);
  const [offerId, setOfferId] = useState<string | undefined>(undefined);
  const { setValue, getValue } = useSessionStorage<string>('soId');
  const { setValue: setOfferIdValue, getValue: getOfferIdValue } = useSessionStorage<string>('offerId');

  useEffect(() => {
    const value = getValue();
    if (value) setSoIdState(value);
    const offerIdValue = getOfferIdValue();
    if (offerIdValue) setOfferId(offerIdValue);
  }, []);

  const handleSetSoId = (id: string | undefined) => {
    setSoIdState(id);
    setValue(id as string);
  };

  const handleSetOfferId = (id: string | undefined) => {
    setOfferId(id);
    setOfferIdValue(id as string);
  };


  const value = {
    soId,
    setSoId: handleSetSoId,
    soInitialData,
    setSoInitialData,
    offerId,
    setOfferId: handleSetOfferId
  };

  return (
    <GeneralSoContext.Provider value={value}>
      {children}
    </GeneralSoContext.Provider>
  );
};

export const useGeneralSoContext = () => {
  const context = useContext(GeneralSoContext);
  if (!context) throw new Error('useGeneralSoContext must be used within GeneralSoProvider');
  return context;
};